module.exports = __webpack_public_path__ + "img/delete-btn.da8ef4f9.svg";